import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { NbToastrService } from '@nebular/theme';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MasterService {
  getAllUsers() {
    throw new Error('Method not implemented.');
  }

  manage_projects_customerData:any = []
  selectedCustomerIds:any = [];
  filteredCustomerList:any = []
  smartsyncTableList:any = []
  smartsyncformdata:any = {}
  FinalMoqData:any = []
  FinalMoqD:any = {}
  showMOQSection:boolean = false
  smartsyncTabContainer:string = "syncVolumeContainer"
  testBack = new Subject<any>();
  testBackSend(data:any){
    this.testBack.next(data)
  }
  testBackrecive(){
    return this.testBack.asObservable()
  }
tablereprestation:any= {}
 
  

  baseUrl = environment.apiUrl;
  constructor(
    private httpClient: HttpClient,
    private notify: NbToastrService
  ) { }
 // ***** Get API's ***** //
  getAllProjectViewInfoData(user_id: number): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/getAlldetails/${user_id}`);
  }
  geAllsourcingParts({}): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_sourcingParts/`, {});
  }
  // get_sourcingParts(data): Observable<any> {
  //   return this.httpClient.post(`${this.baseUrl}/get_sourcingParts/`, data);
  // }

  getParts_offer_details(data): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/getParts_offer_details/`, data);
  }

  engineers(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/engineers`);
  }

  // ***** Post API's ***** //
  // login(username: any, password: any, role:any): Observable<any> {
  //   return this.httpClient.post(`${this.baseUrl}/login?username=${username}&password=${password}&role=${role}` );
  // }
  // login(username: string, password: string, role: string): Observable<any> {
  //   // Construct the URL dynamically
  //   const url = `${this.baseUrl}/login?username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}&role=${encodeURIComponent(role)}`;    
  //   return this.httpClient.post(url, null); 
  // }
  login(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/login`, data);
  }

  // finalCompareData(parts: any): Observable<any> {
  //   return this.httpClient.post(`${this.baseUrl}/postBOM`, parts);
  // }

  // finalCompareData(parts: any): Observable<any> {
  //   return this.httpClient.post(`${this.baseUrl}/sourcing_parts_bynexar/`, parts);
  // }

  // finalCompareData(encodedParts: string): Observable<any> {
  //   return this.httpClient.post(`${this.baseUrl}/postBOM`, { data: encodedParts });
  // }

  add_project(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/add_project`, data);
  }
  // manage_projects(data: any): Observable<any> {
  //   return this.httpClient.post(`${this.baseUrl}/manage_projects/`, data);
  // }

  manage_projects(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/manage_projects/`, data).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('API Request Failed:', error);        
        let errorMessage = 'Something went wrong. Please try again.';        
        if (error.status === 500) {
          errorMessage = 'Server error: 500 Internal Server Error. Please try again later.';
        } else if (error.status === 0) {
          errorMessage = 'Network error: Unable to reach the server.';
        } else if (error.error?.message) {
          errorMessage = error.error.message; // If API returns a custom error message
        }  
        // Show error notification
        this.notify.danger(errorMessage);  
        return throwError(() => new Error(errorMessage));
      })
    );
  }
  
  add_customer(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/add_customer`, data);
  }
  all_customers(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/manage_customers/`, data);
  }
  // create_customers(data: any): Observable<any> {
  //   return this.httpClient.post(`${this.baseUrl}/manage_customers/`, data);
  // }
  create_customers(data: any): Observable<any> {
  return this.httpClient.post(`${this.baseUrl}/customers/create`, data);
}

  get_manager_and_engineers(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_manager_and_engineers/`, data);
  }

  // new APis
//  get_Projectview({ }): Observable<any> {
//     return this.httpClient.post(`${this.baseUrl}/get_Projectview`, {});
//   }
get_Projectview(payload: any): Observable<any> {
  return this.httpClient.post(`${this.baseUrl}/get_Projectview`, payload);
}

  get_Projectview_part(project_id: number, version_id: number): Observable<any> {
  const url = `${this.baseUrl}/get_Projectview`; // <-- change base URL if needed
  const payload = {
    project_id,
    version_id
  };

  return this.httpClient.post(url, payload);
}


  get_project_parts_part_details_Top_N_Seller(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_project_parts_part_details_Top_N_Seller`, data);
  }
  get_project_part_details_Top_N_Seller(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_project_part_details_Top_N_Seller`, data);
  }

  // finalCompareData(parts: any): Observable<any> {
  //   return this.httpClient.post(`${this.baseUrl}/sourcing_parts_bynexar_v1`, parts);
  // }
  finalCompareData(parts: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/trigger_sourcing_parts_task`, parts);
  }

  get_ProjectviewWithProjectIdAndVersionId(data): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_Projectview`, data);
  }
  
  get_offer_price(data): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_offer_price`, data);
  }

  add_user(data) : Observable<any>{
    return this.httpClient.post(`${this.baseUrl}/manage_users`, data)
  }

  get_All_roles({}) :  Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/Getrolemaster`, {})
  }

  update_Finalise_project_part(data) : Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/UpdateFinaliseProjectPart`, data)
  }
  
  manufacturer_Name_search(data) : Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/manufacturer_Name_search`, data)
  }
  sync_project_part(data): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/sync_project_part`, data);
  }

  calculate_duty_cost(data): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/calculate_duty_cost/`, data);
  }
  
  get_sync_consolidation_parts(data): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_sync_consolidation_parts`, data); 
  }
  get_frequency(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/get_frequency`);
  }
  create_part_alert(data): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/create_part_alert`, data);   
  }
  list_parts_alert(data): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/list_parts_alert`, data); 
  }
  save_sync_cosolidate_final_part(data): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/save_sync_cosolidate_final_part`, data);   
  }
  fetch_sync_cosolidate_final_part(data): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/fetch_sync_consolidation_final_part`, data);   
  }  
 delete_part_alert(job_id: string): Observable<any> {
  return this.httpClient.delete(`${this.baseUrl}/delete_part_alert/${job_id}`);
}
 analyze_html(data): Observable<any> {
  return this.httpClient.post(`${'https://ai.syntheta.net/api/analyze/html'}`,data);
}
sync_project_parts_moq(data): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/sync_project_parts_moq`, data);
  }
   calculate_freight_matrix(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/calculate_freight_matrix`);
  }
   calculate_duty_matrix(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/calculate_duty_matrix`);
  }
   uploadPoData(parts: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/purchase-orders/upload`, parts);
  }
     uploadVendorData(parts: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/suppliers/upload`, parts);
  }
fetchPartDetails(payload: any): Observable<any> {
  return this.httpClient.post(`${this.baseUrl}/fetch-part-details`, payload);
}
createSupplier(payload: any): Observable<any> {
  return this.httpClient.post(`${this.baseUrl}/suppliers`, payload);
}
// master.service.ts
// getSuppliers(skip: number = 0, limit?: number): Observable<any> {
//   let url = `${this.baseUrl}/suppliers?skip=${skip}&limit=${limit}`;
//   // if (limit !== undefined) { url += `&limit=${limit}`; }
//   
//   return this.httpClient.get(url);
// }
getSuppliers(skip: number = 0, limit: number = 10): Observable<any> {
  let url = `${this.baseUrl}/suppliers?skip=${skip}&limit=${limit}`;
  
  return this.httpClient.get(url);
}

deleteSupplier(supplierId: string): Observable<any> {
  return this.httpClient.delete(`${this.baseUrl}/suppliers/${supplierId}`);
}
updateSupplier(supplierId: string, supplierData: any): Observable<any> {
  return this.httpClient.put(`${this.baseUrl}/suppliers/${supplierId}`, supplierData);
}
  getSupplierById(supplierId: string): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/suppliers/${supplierId}`);
    
  }
  // master.service.ts
getPurchaseOrders(skip = 0, limit = 10) {
  return this.httpClient.get<any[]>(`${this.baseUrl}/purchase-orders?skip=${skip}&limit=${limit}`);
}
 



uploadAttachments(internalPartNo: string, files: File[]): Observable<any> {
  const formData = new FormData();

  files.forEach((file: File) => {
    formData.append('files', file, file.name);
  });

  formData.append('internalPartNo', internalPartNo);

  // Upload ki POST / PUT ekkada API docs lo ela unnado check chesuko
  return this.httpClient.post(`${this.baseUrl}/upload_files`, formData);
}




// submitRFQ(payload: any): Observable<any> {
//   return this.httpClient.post(`${this.baseUrl}/offline_vendor_sourcing`, payload);
// }
submitRFQ(payload: any, sendEmail: boolean = true): Observable<any> {
  return this.httpClient.post(
    `${this.baseUrl}/offline_vendor_sourcing/create?send_email=${sendEmail}`,
    payload
  );
}

   getEmailTemplateCategories(skip: number = 0, limit: number = 50): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrl}/email-template-categories?skip=${skip}&limit=${limit}`);
  }

updateSourcingParts(payload: any) {
  const url = `${this.baseUrl}/offline_vendor_sourcing/parts/update`;
  return this.httpClient.put(url, payload);
}

getOfflineVendorSourcing(project_id: string, version_id: string): Observable<any> {
  return this.httpClient.get(`${this.baseUrl}/offline_vendor_sourcing/${project_id}/${version_id}`);
}
getEmailTemplates(skip: number = 0, limit: number = 10, category: string = ''): Observable<any> {
  let url = `${this.baseUrl}/email-templates?skip=${skip}&limit=${limit}`;
  if (category) {
    url += `&category=${category}`;
  }
  return this.httpClient.get<any>(url);
}
createEmailTemplate(payload: any): Observable<any> {
  return this.httpClient.post(`${this.baseUrl}/email-templates`, payload);
}
updateEmailTemplate(id: string, payload: any): Observable<any> {
  return this.httpClient.put(`${this.baseUrl}/email-templates/${id}`, payload);
}


// DELETE
deleteEmailTemplate(id: string): Observable<any> {
  return this.httpClient.delete(`${this.baseUrl}/email-templates/${id}`);
}
getCategories() {
  return this.httpClient.get(`${this.baseUrl}/email_templates`);
}


getEmailTemplatesid(templateName: string) {
  return this.httpClient.get(`${this.baseUrl}/email_templates?templateName=${templateName}`);
}
  getSampleEmailTemplate() {
    return this.httpClient.get(`${this.baseUrl}/email_template`);
  }
searchSuppliers(search: string, skip: number = 0, limit: number = 10): Observable<any> {
  const url = `${this.baseUrl}/suppliers/search?search=${search}&skip=${skip}&limit=${limit}`;
  // encodeURIComponent()
  console.log('searchSuppliers =>', url);
  return this.httpClient.get(url);
}


  //  sendRfqEmail(rfqId: string,payload: any): Observable<any> {
  //   return this.httpClient.put(`${this.baseUrl}/offline_vendor_sourcing/rfqs/${rfqId}`, payload);
  // }
  sendRfqEmail(rfqId: string, payload: any, sendEmailFlag: boolean) {
  return this.httpClient.put(
    `${this.baseUrl}/offline_vendor_sourcing/rfqs/${rfqId}?send_email_flag=${sendEmailFlag}`,
    payload
  );
}

getEmailTemplateCollections(): Observable<any> {
 return this.httpClient.get(`${this.baseUrl}/email-template-collections`);

}

 getEmailTemplateMetaFields(collection: string): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/email-meta-fields`, {
      params: { collection_name: collection }
    });
  }



  downloadFileWithAuth(fileId: string): Observable<Blob> {
    const url = `${this.baseUrl}/download_file/${fileId}`;
    return this.httpClient.get(url, { responseType: 'blob' });
  }
getEmailTemplatesByCategory(category: string) {
  const params: any = {
    skip: 0,
    limit: 10,
    category
    // collection_name is intentionally omitted if not needed
  };
  return this.httpClient.get(`${this.baseUrl}/email-templates`, { params });
}

getPartPriceHistoryInternal1(internalPartNo: string) {
  return this.httpClient.get(`${this.baseUrl}/part_history_ipn?internalPartNumber=${internalPartNo}`);
}

getPartPriceHistoryInternal(internalPartNo: string, projectId: any, versionId: number, commodity: string) {

  const body = {
    internalPartNumber: internalPartNo,
    project_id: projectId,
    version_id: versionId,
    commodity: commodity
  };

  return this.httpClient.post(`${this.baseUrl}/part_history_ipn`, body);
}



getRfqFollowups(rfqId: string) {
  return this.httpClient.get(`${this.baseUrl}/offline_vendor_sourcing/rfqs/${rfqId}`);
}


getCustomers(payload: any): Observable<any> {
  return this.httpClient.post(`${this.baseUrl}/customers/`, payload);
}


updateCustomer(payload: any): Observable<any> {
  return this.httpClient.put(`${this.baseUrl}/customers/update`, payload);
}
softDeleteCustomer(customerId: number) {
  return this.httpClient.delete(
    `${this.baseUrl}/customers/soft_delete/${customerId}`
  );
}
// master.service.ts
getInputSourceDropdown(projectId: number, versionId: number) {
  return this.httpClient.get(
    `${this.baseUrl}/get_Input_source_data/projects/${projectId}/versions/${versionId}/dropdown-options`
  );
  
}



}


